export abstract class EventV2<EventData> {
  protected name?: string;
  protected data: EventData;

  constructor(data: EventData) {
    this.data = data;

    const name = this.name;
    if (name) {
      Object.defineProperty(this.constructor, 'name', {
        value: name,
      });
    }
  }

  public get() {
    return { type: this.constructor.name, data: this?.data };
  }
}
